import { cn } from '@/shared/lib/utils'
import { AGENTS, FEATURED_AGENT } from '@/features/agents/data/agents-dashboard-data'
import { useAssistantStore } from '../store/assistant-store'
import { ASSISTANT_CONVERSATIONS } from '../data/assistant-conversations'
import { AssistantHeader } from './assistant-header'
import { AssistantMessageList } from './assistant-message-list'
import { AssistantInputBar } from './assistant-input-bar'
import type { AgentId } from '../types/assistant'

const ALL_AGENTS = [FEATURED_AGENT, ...AGENTS]

function getAgentData(agentId: AgentId) {
  const found = ALL_AGENTS.find((a) => a.id === agentId)
  return found ?? FEATURED_AGENT
}

export function FloatingAssistantPanel() {
  const { isOpen, currentAgentId } = useAssistantStore()

  const agent = getAgentData(currentAgentId)
  const conversation = ASSISTANT_CONVERSATIONS[currentAgentId]

  return (
    <div
      className={cn(
        'fixed top-14 right-0 z-40 flex flex-col h-[calc(100vh-3.5rem)] w-[40vw] min-w-[380px] max-w-[860px] border-l bg-card shadow-2xl overflow-hidden transition-transform duration-300 ease-out',
        isOpen ? 'translate-x-0' : 'translate-x-full pointer-events-none',
      )}
      role="dialog"
      aria-hidden={!isOpen}
      aria-label={`${agent.name} AI Assistant`}
    >
      <AssistantHeader
        agentId={currentAgentId}
        agentName={agent.name}
        agentRole={agent.role}
        agentColor={agent.avatarColor}
        agentInitials={agent.avatarInitials}
      />
      <AssistantMessageList
        messages={conversation.messages}
        agentInitials={agent.avatarInitials}
        agentColor={agent.avatarColor}
      />
      <AssistantInputBar chips={conversation.chips} agentName={agent.name} />
    </div>
  )
}
